import { isUserLoggedIn } from '../../utils/authUtils';
import { getPartialModel } from '../../utils/modelUtils';
import { CrudServiceBase } from '../base/crudServiceBase';
import Endpoint from '../endpoint';
import { httpApi } from '../httpService';
import { PolicyPurchaseRatingDto } from './dto/policyPurchaseRatingDto';

export class PolicyPurchaseRatingService extends CrudServiceBase<PolicyPurchaseRatingDto> {
    constructor() {
        super(Endpoint.PolicyPurchaseRating);
        this.internalHttp = httpApi;
    }

    public async create(createPolicyPurchaseRatingInput: PolicyPurchaseRatingDto) {
        isUserLoggedIn();

        let newCreatePolicyPurchaseRatingInput = getPartialModel(createPolicyPurchaseRatingInput, [], ['id']);

        let result = await this.internalHttp.post(this.endpoint.Create(), newCreatePolicyPurchaseRatingInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async update(updatePolicyPurchaseRatingInput: PolicyPurchaseRatingDto) {
        isUserLoggedIn();

        let newUpdatePolicyPurchaseRatingInput = getPartialModel(updatePolicyPurchaseRatingInput, [], ['lastModificationTime', 'lastModifierUserId']);

        let result = await this.internalHttp.put(this.endpoint.Update(), newUpdatePolicyPurchaseRatingInput);
        return !!result.data && !!result.data.result ? result.data.result : result.data;
    }

    public async delete(deletePolicyPurchaseRatingInput: PolicyPurchaseRatingDto) {
        isUserLoggedIn();
        
        let newDeletePolicyPurchaseRatingInput = getPartialModel(deletePolicyPurchaseRatingInput, ['id'], []);

        let result = await this.internalHttp.delete(this.endpoint.Delete(), { params: newDeletePolicyPurchaseRatingInput });
        return result.data;
    }

    async exportToExcel(ids?: number[]) {
        if(ids && Array.isArray(ids)) {
          const sorted: number[] = ids.sort();
          let endpointString: string = 'ExportToExcel?';

          sorted.forEach((id: number, index: number) => {
            endpointString = endpointString + `${index === 0 ? '' : '&'}Ids=${id}`;
          });
          
          return await this.internalHttp.get(this.endpoint.Custom(endpointString, true));
        } else {
          return await this.internalHttp.get(this.endpoint.Custom(`ExportToExcel`, true));
        }
    }
}

const exportPolicyPurchaseRatingService: PolicyPurchaseRatingService = new PolicyPurchaseRatingService();
export default exportPolicyPurchaseRatingService;